import type { QueryClient } from '@tanstack/react-query'

export function convert(queryClient: QueryClient) {
  return (module: any) => ({
    Component: module.Component || module.default,
    loader: module.loader?.(queryClient),
    action: module.action,
  })
}
